import type * as Types from '../types';

const getChildrenMissingBirthday = (children: Array<Types.Child>): Array<Types.Child> => {
    return children.filter(child => child.birthday === null);
};

export {getChildrenMissingBirthday};
